// extracted by mini-css-extract-plugin
module.exports = {"externalIcon":"link_externalIcon__XZqmM"};